import { render, staticRenderFns } from "./CardMention.vue?vue&type=template&id=fd71e9a4"
import script from "./CardMention.vue?vue&type=script&lang=js"
export * from "./CardMention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports